import { useQuery } from "react-query";
import { getAllInvitesRequest } from "./request";


export const useFetchInvitesAll = () => {
    return useQuery(["UseInvitesAll"], getAllInvitesRequest);
};